// import React, { ReactNode } from 'react';
// import './Background.css';

// interface BackgroundProps {
//   children: ReactNode;
// }

// const Background: React.FC<BackgroundProps> = ({ children }) => (
//   <div className="blue-box">{children}</div>
// );

// export default Background;

import React, { ReactNode } from 'react';
import './Background.css';

interface BackgroundProps {
  children: ReactNode;
}

const Background: React.FC<BackgroundProps> = ({ children }) => (
  <div className="blue-box">
    <div className="blue-box-inner">{children}</div>
  </div>
);

export default Background;
